export default __webpack_public_path__ + "static/media/Montserrat-Thin.4a799b11.ttf";